import { render } from "./backofficeCustom.vue?vue&type=template&id=06d88ce0&ts=true"
import script from "./backofficeCustom.vue?vue&type=script&lang=ts"
export * from "./backofficeCustom.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\Auraclub\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__